import { gql, useQuery } from '@apollo/client';
import { useLogger } from '@amzn/xb-hooks';

export const LEARNER_CQ_PROGRESS = gql`
    query LearnerCQProgress($userId: ID!, $cqCatalogItemId: ID!) {
        catalogItemById(id: $cqCatalogItemId) {
            name
            trainingDeliveryUrl
            children {
                nodes {
                    id
                    name
                    description
                }
            }
        }
        transcriptByUserIdAndCatalogItemId(userId: $userId, catalogItemId: $cqCatalogItemId) {
            digitalTranscriptStatus
            numberOfCompletedCourses
            moduleDetails {
                moduleLevelCatalogItemID
                status
            }
        }
    }
`;

export interface CQModule {
    id: string;
    name: string;
    description: string;
}

export interface CQModuleProgress {
    moduleLevelCatalogItemID: string;
    status: 'COMPLETED' | 'IN_PROGRESS' | 'NOT_STARTED';
}

export interface CQTranscript {
    digitalTranscriptStatus: string;
    numberOfCompletedCourses: number;
    moduleDetails: CQModuleProgress[];
}

export interface LearnerCQProgressData {
    catalogItemById: {
        name: string;
        trainingDeliveryUrl?: string;
        children: {
            nodes: CQModule[];
        };
    } | null;
    transcriptByUserIdAndCatalogItemId: CQTranscript | null;
}

export const useLearnerCQProgress = (userId: string | undefined, cqCatalogItemId: string) => {
    const { log, count } = useLogger();

    return useQuery<LearnerCQProgressData>(LEARNER_CQ_PROGRESS, {
        skip: !userId || !cqCatalogItemId,
        variables: {
            userId,
            cqCatalogItemId,
        },
        onError: (error) => {
            log.error('Error fetching Cloud Quest progress', error);
            count('CloudQuestProgress.Error');
        },
    });
};
